import { LazyLoadImage } from 'react-lazy-load-image-component';

import { ParallaxLayer } from '@r1-frontend/ui-react/components/animation/Parallax';
import { IndentContainer, ListContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';

import { PromoTextWithStyleHeading1 } from '~/src/features/internetV2/components/typography';
import HeaderCarousel from '~/src/features/internetV2/containers/SpeedLineContainer/HeaderCarousel';
import SpeedLineContainer from '~/src/features/internetV2/containers/SpeedLineContainer/SpeedLineContainer';
import Blur from '~/static/images/internet/v2/icons/blur.png';
import Cloud from '~/static/images/internet/v2/icons/cloud.png';
import Gaming from '~/static/images/internet/v2/icons/gaming.png';
import Music from '~/static/images/internet/v2/icons/music.png';
import Play from '~/static/images/internet/v2/icons/play.png';
import Router from '~/static/images/internet/v2/icons/router.png';
import Speed from '~/static/images/internet/v2/icons/speed.png';
import Video from '~/static/images/internet/v2/icons/video.png';

import * as ST from '~/src/features/internetV2/containers/SpeedLineContainer/styled';

interface IDesktopSpeedLineContainer {
    children: JSX.Element,
}

const DesktopSpeedLineContainer = ({ children }: IDesktopSpeedLineContainer): JSX.Element => {
    return (
        <ST.SpeedLineContainer>
            <NonStaticContainer
                $united={{
                    $position: 'relative',
                }}
            >
                <IndentContainer $united={[0, 0, 36, 0]}>
                    <ListContainer $size={0} $direction={'column'}>
                        {children}
                        <PromoTextWithStyleHeading1>Новый интернет Дом.ру:</PromoTextWithStyleHeading1>
                        <HeaderCarousel>
                            <PromoTextWithStyleHeading1>стабильный</PromoTextWithStyleHeading1>
                            <PromoTextWithStyleHeading1>быстрый</PromoTextWithStyleHeading1>
                            <PromoTextWithStyleHeading1>умный</PromoTextWithStyleHeading1>
                        </HeaderCarousel>
                    </ListContainer>
                </IndentContainer>

                {/* Parallax absolute elements */}
                <ST.NonStaticContainerWithRotation
                    $united={{
                        $top: 70,
                        $left: -100,
                        $zIndex: -1,
                    }}
                    $rotate={-30}
                >
                    <ParallaxLayer $translateOffset={[0, 0.2]}>
                        <LazyLoadImage src={Music} width={68} height={70} />
                    </ParallaxLayer>
                </ST.NonStaticContainerWithRotation>

                <ST.NonStaticContainerWithRotation
                    $united={{
                        $top: 30,
                        $right: -70,
                        $zIndex: -1,
                    }}
                    $rotate={15}
                >
                    <ParallaxLayer $translateOffset={[0, 0.2]}>
                        <LazyLoadImage src={Speed} width={68} height={70} />
                    </ParallaxLayer>
                </ST.NonStaticContainerWithRotation>
            </NonStaticContainer>

            <SpeedLineContainer />

            {/* Parallax absolute elements */}
            <ST.NonStaticContainerWithRotation
                $united={{
                    $top: 130,
                    $left: 50,
                    $zIndex: -1,
                }}
                $rotate={0}
            >
                <ParallaxLayer $translateOffset={[0, 0.3]}>
                    <LazyLoadImage src={Play} width={68} height={68} />
                </ParallaxLayer>
            </ST.NonStaticContainerWithRotation>

            <ST.NonStaticContainerWithRotation
                $united={{
                    $top: 400,
                    $left: 150,
                    $zIndex: -1,
                }}
                $rotate={15}
            >
                <ParallaxLayer $translateOffset={[0, 0.1]}>
                    <LazyLoadImage src={Video} width={68} height={70} />
                </ParallaxLayer>
            </ST.NonStaticContainerWithRotation>

            <ST.NonStaticContainerWithRotation
                $united={{
                    $top: 100,
                    $right: 100,
                    $zIndex: -1,
                }}
                $rotate={15}
            >
                <ParallaxLayer $translateOffset={[0, 0.2]}>
                    <LazyLoadImage src={Cloud} width={100} height={100} />
                </ParallaxLayer>
            </ST.NonStaticContainerWithRotation>

            <ST.NonStaticContainerWithRotation
                $united={{
                    $top: 500,
                    $left: -30,
                    $zIndex: -1,
                }}
                $rotate={-35}
            >
                <ParallaxLayer $translateOffset={[0, 0.1]}>
                    <LazyLoadImage src={Blur} width={100} height={100} />
                </ParallaxLayer>
            </ST.NonStaticContainerWithRotation>

            <NonStaticContainer
                $united={{
                    $top: 192,
                    $right: 34,
                    $zIndex: -1,
                }}
            >
                <ParallaxLayer $translateOffset={[0, 0.3]}>
                    <LazyLoadImage src={Router} width={68} height={70} />
                </ParallaxLayer>
            </NonStaticContainer>

            <ST.NonStaticContainerWithRotation
                $united={{
                    $top: 333,
                    $right: -10,
                    $zIndex: -1,
                }}
                $rotate={15}
            >
                <ParallaxLayer $translateOffset={[0, 0.6]}>
                    <LazyLoadImage src={Gaming} width={68} height={70} />
                </ParallaxLayer>
            </ST.NonStaticContainerWithRotation>
        </ST.SpeedLineContainer>
    );
};

export default DesktopSpeedLineContainer;
